import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { createMessage } from '../../utility/createMessage';
import { variants } from '../../../../variants/variants';
import { selectDraft, selectPreview, sendIncomingMessage, setAnswer, setDraftAnswer } from '../../giftSlice';

const SelectAnswer = ({ designation, title, question, editable = false, textField = false, handleError }) => {
  const completed = useSelector(selectPreview);
  const dispatch = useDispatch();
  const [disableOptions, setDisabledOptions] = useState(false);
  const [value, setValue] = useState('');
  const draft = useSelector(selectDraft);
  const handleSelectAnswer = e => {
    let value = e.target.value;
    setValue(value);
    if (editable) {
      dispatch(setDraftAnswer({ answer: value, designation, title, question }));
      //if yes then show message to give a reason and disable save changes button
      if (value === 'yes') handleError(true);
      //else remove the error and enable the save changes button
      else handleError(false);
      return;
    }
    dispatch(setAnswer({ answer: value }));
    setDisabledOptions(true);
    if (value === 'yes') {
      const incoming = createMessage('If yes then an example wherein you have done this');
      return dispatch(sendIncomingMessage({ message: incoming, duration: 500, allowInput: true }));
    }
    //send next question
    dispatch(sendIncomingMessage({ duration: 500 }));
  };
  useEffect(() => {
    let savedValue = null;
    savedValue =
      completed &&
      completed[designation] &&
      completed[designation][title] &&
      completed[designation][title][question]?.answer;
    if (savedValue) {
      setValue(savedValue);
      setDisabledOptions(true);
    }
    if (editable) {
      setDisabledOptions(false);
    }
  }, []);
  return (
    <FormControl>
      <FormLabel id='answer' sx={{ fontSize: variants.TINY }}>
        Select your answer
      </FormLabel>
      <RadioGroup row aria-labelledby='answer' name='answer' onChange={handleSelectAnswer} value={value}>
        <FormControlLabel
          value='yes'
          control={<Radio size='small' />}
          label='Yes'
          disabled={disableOptions}
          sx={{ '> span': { fontSize: variants.TINY } }}
        />
        <FormControlLabel
          value='no'
          control={<Radio size='small' />}
          label='No'
          disabled={disableOptions}
          sx={{ '> span': { fontSize: variants.TINY } }}
        />
        <FormControlLabel
          value='na'
          control={<Radio size='small' />}
          label='NA'
          disabled={disableOptions}
          sx={{ '> span': { fontSize: variants.TINY } }}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default SelectAnswer;
